import React, { memo } from "react";
import { DeleteIcon } from "@chakra-ui/icons";
import { Box } from "@chakra-ui/layout";
import { HStack, IconButton, SkeletonText, Tooltip } from "@chakra-ui/react";
import { Table, Tbody, Td, Th, Tr, Thead } from "@chakra-ui/table";
import { CherryHubAdminApi } from "../../api/adminApiModels";

interface GeoLocationGroupsTableProps {
  geoLocationGroups: CherryHubAdminApi.GeoLocationGroup[] | null;
  isLoading: boolean;
  disableActions?: boolean;
  onClickGeoLocationGroup: (
    geoLocationGroup: CherryHubAdminApi.GeoLocationGroup
  ) => void;
  onClickDeleteGeoLocationGroup: (
    geoLocationGroup: CherryHubAdminApi.GeoLocationGroup
  ) => void;
}

export const GeoLocationGroupsTable = memo(
  ({
    geoLocationGroups,
    isLoading,
    disableActions,
    onClickGeoLocationGroup,
    onClickDeleteGeoLocationGroup,
  }: GeoLocationGroupsTableProps) => {
    return (
      <Box w="100%" overflowX="auto">
        <Table size="sm">
          <Thead>
            <Tr>
              <Th>Display Name</Th>
              <Th>Geo Location Count</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {!isLoading &&
              (geoLocationGroups ?? []).map((geoLocationGroup) => (
                <Tr key={geoLocationGroup.GeoLocationGroupId}>
                  <Td
                    title="View geo location group."
                    _hover={{
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => onClickGeoLocationGroup(geoLocationGroup)}
                  >
                    {geoLocationGroup.DisplayName ?? "-"}
                  </Td>
                  <Td whiteSpace="nowrap">
                    {geoLocationGroup.GeoLocationIds?.length ?? 0}
                  </Td>
                  <Td width="0.1%" whiteSpace="nowrap">
                    <HStack spacing={2} justifyContent="center">
                      <Tooltip
                        label={`Delete "${geoLocationGroup.DisplayName ?? ""}"`}
                        placement="top"
                      >
                        <IconButton
                          aria-label={`Delete "${
                            geoLocationGroup.DisplayName ?? ""
                          }"`}
                          icon={<DeleteIcon />}
                          size="xs"
                          isDisabled={disableActions}
                          onClick={() =>
                            onClickDeleteGeoLocationGroup(geoLocationGroup)
                          }
                        />
                      </Tooltip>
                    </HStack>
                  </Td>
                </Tr>
              ))}
            {geoLocationGroups?.length === 0 && !isLoading && (
              <Tr>
                <Td colSpan={3} textAlign="center">
                  No geo location groups found.
                </Td>
              </Tr>
            )}
            {isLoading && (
              <Tr>
                <Td colSpan={3}>
                  <SkeletonText noOfLines={6} spacing="4" width="100%" />
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Box>
    );
  }
);
